import { render, staticRenderFns } from "./ValidationMessage.vue?vue&type=template&id=95bd7de6&scoped=true&"
var script = {}
import style0 from "./ValidationMessage.vue?vue&type=style&index=0&id=95bd7de6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bd7de6",
  null
  
)

export default component.exports